import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ExportButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Export
    </Button>
  );
}
